module.exports = __webpack_public_path__ + "img/1-8.1088c20e.png";